
const ASSET_DECIMALS: Record<string, number> = {
  BRL: 2,
  'R$': 2,   // simbolo do BRL usado no sistema
  REAL: 2,   // nome do asset BRL
  USD: 2,
  EUR: 2,
  ARS: 2,
  BTC: 8,
  ETH: 18,
  MATIC: 18,
  BNB: 18,
  AVAX: 18,
  SOL: 9,
  USDT: 6,
  USDC: 6,
  DAI: 6,
  TRX: 6,
};

const FIAT_SYMBOLS = new Set(['BRL', 'R$', 'REAL', 'USD', 'EUR', 'ARS']);

// Mapeia simbolo/nome fiat -> codigo ISO valido (Intl currency exige ISO).
const FIAT_ISO: Record<string, string> = {
  'R$': 'BRL', REAL: 'BRL', BRL: 'BRL',
  'US$': 'USD', USD: 'USD',
  EUR: 'EUR', ARS: 'ARS',
};

const DEFAULT_CRYPTO_DECIMALS = 8;

export const getAssetDecimals = (symbol?: string | null): number => {
  if (!symbol) return DEFAULT_CRYPTO_DECIMALS;
  const key = symbol.toUpperCase();
  return ASSET_DECIMALS[key] ?? DEFAULT_CRYPTO_DECIMALS;
};

export const isFiat = (symbol?: string | null): boolean => {
  if (!symbol) return false;
  return FIAT_SYMBOLS.has(symbol.toUpperCase());
};

const toNumber = (value: string | number | null | undefined): number => {
  if (value === null || value === undefined || value === '') return 0;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const formatAssetAmount = (
  value: string | number | null | undefined,
  symbol?: string | null,
  opts: { locale?: string; trim?: boolean } = {},
): string => {
  const { locale = 'pt-BR', trim = true } = opts;
  const decimals = getAssetDecimals(symbol);
  const n = toNumber(value);

  if (isFiat(symbol)) {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(n);
  }

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: trim ? 0 : decimals,
    maximumFractionDigits: decimals,
  }).format(n);
};


export const formatAssetWithSymbol = (
  value: string | number | null | undefined,
  symbol?: string | null,
  opts?: { locale?: string },
): string => {
  if (isFiat(symbol)) {
    const locale = opts?.locale ?? 'pt-BR';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: FIAT_ISO[(symbol ?? 'BRL').toUpperCase()] ?? 'BRL',
      minimumFractionDigits: getAssetDecimals(symbol),
      maximumFractionDigits: getAssetDecimals(symbol),
    }).format(toNumber(value));
  }
  return `${(symbol ?? '').toUpperCase()} ${formatAssetAmount(value, symbol, opts)}`.trim();
};
